module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-sh.b9f0ba92.png";